import { createApp } from 'vue';
import App from './App.vue';
import store from './store'; // 引入 Vuex store
import router from './router'; // 引入 Vue Router
import { CSSApi, ShopInfoApi, PaymentSettingApi, DeliverySettingApi, ShopOtherSettingApi } from "@/api/productDataApi";

async function bootstrap() {
    // 更新 shopID 到 Vuex Store

    //預載 CSS
    try {
        const styleConfig = await CSSApi();
        console.log("styleConfig:" + styleConfig);

        Object.entries(styleConfig.data[0]).forEach(([key, value]) => {
            if (['id', 'shopID'].includes(key)) return;
            //console.log("Key:" + key + " value: " + value);
            document.documentElement.style.setProperty(`--${key}`, value);
    });
    } catch (error) {
        console.error("CSS API 请求失败:", error);
    }

    //預載 Shop Info

    try {
        const settingData = await ShopInfoApi();

    if (settingData) {
        store.commit('setShopInfoSettings', settingData);
        console.log("✅ Shop Info setting 已載入:", settingData);
    } else {
        console.warn("⚠️ 找不到對應的 ShopSetting 記錄");
    }

    } catch (err) {
        console.error("❌ 載入 shop Info setting 失敗:", err);
    }

    //預載 Payment Setting, rate setting, 

    try {
        const settingData = await PaymentSettingApi();
        const defaultCurrency = settingData.VUE_APP_DEFAULT_CURRENCY || 'HKD';

    if (settingData) {
        store.commit('setPaymentSettings', settingData);
        // 使用上面的 Payment Setting, 找取 DEFAULT CURRENCY, 再更新 store data 內的 currency, rate, rate country
        store.commit('setSelectedCurrency', defaultCurrency);
        console.log("✅ Payment Setting, rate setting 已載入:", settingData);
    } else {
        console.warn("⚠️ 找不到對應的 Payment Setting 記錄");
    }

    } catch (err) {
        console.error("❌ 載入 Payment Setting 失敗:", err);
    }

    //預載 Delivery Setting 

    try {
        const settingData = await DeliverySettingApi();

    if (settingData) {
        store.commit('setDeliverySettings', settingData);
        console.log("✅ Delivery Setting 已載入:", settingData);
    } else {
        console.warn("⚠️ 找不到對應的 Delivery Setting 記錄");
    }

    } catch (err) {
        console.error("❌ 載入 Delivery Setting 失敗:", err);
    }

    //預載 Shop Other Setting 

    try {
        const settingData = await ShopOtherSettingApi();
        const defaultLanguage = settingData.VUE_APP_DEFAULT_LANGUAGE || 'CN';

    if (settingData) {
        store.commit('setShopOtherSettings', settingData);
        store.commit('setSelectedLanguage', defaultLanguage);
        console.log("✅ Shop Other Setting 已載入:", settingData);
    } else {
        console.warn("⚠️ 找不到對應的 Shop Other Setting 記錄");
    }

    } catch (err) {
        console.error("❌ 載入 Delivery Setting 失敗:", err);
    }


/*
    document.documentElement.style.setProperty('--body-background-color', process.env.VUE_APP_BODY_BACKGROUND_COLOR);
    document.documentElement.style.setProperty('--body-font-color', process.env.VUE_APP_BODY_FONT_COLOR);
    document.documentElement.style.setProperty('--fourServices-background-color', process.env.VUE_APP_FOURSERVICES_BACKGROUND_COLOR);
    document.documentElement.style.setProperty('--header-background-color', process.env.VUE_APP_HEADER_BACKGROUND_COLOR);
    document.documentElement.style.setProperty('--header-font-color', process.env.VUE_APP_HEADER_FONT_COLOR);
    document.documentElement.style.setProperty('--footer-background-color', process.env.VUE_APP_FOOTER_BACKGROUND_COLOR);
    document.documentElement.style.setProperty('--footer-font-color', process.env.VUE_APP_FOOTER_FONT_COLOR);
    document.documentElement.style.setProperty('--header-selected-font-color', process.env.VUE_APP_HEADER_SELECTED_FONT_COLOR);
    document.documentElement.style.setProperty('--increase-button-color', process.env.VUE_APP_INCREASE_BUTTON_COLOR);
    document.documentElement.style.setProperty('--button-background-color', process.env.VUE_APP_BUTTON_BACKGROUND_COLOR);
    document.documentElement.style.setProperty('--button-border-color', process.env.VUE_APP_BUTTON_BORDER_COLOR);
    document.documentElement.style.setProperty('--product-list-font-color', process.env.VUE_APP_PRODUCT_LIST_FONT_COLOR);
    document.documentElement.style.setProperty('--currency-font-color', process.env.VUE_APP_CURRENCY_FONT_COLOR);
    document.documentElement.style.setProperty('--cart-count-background-color', process.env.VUE_APP_CART_COUNT_BACKGROUND_COLOR);
    document.documentElement.style.setProperty('--link-selected-color', process.env.VUE_APP_LINK_SELECTED_COLOR);
    document.documentElement.style.setProperty('--feature-background-color', process.env.VUE_APP_FEATURE_BACKGROUND_COLOR);
    document.documentElement.style.setProperty('--feature-border-color', process.env.VUE_APP_FEATURE_BORDER_COLOR);
    document.documentElement.style.setProperty('--feature-text-color', process.env.VUE_APP_FEATURE_TEXT_COLOR);

    document.documentElement.style.setProperty('--pages-font', process.env.VUE_APP_PAGES_FONT);
    document.documentElement.style.setProperty('--pages-number-font', process.env.VUE_APP_PAGES_NUMBER_FONT);
    document.documentElement.style.setProperty('--homepage-price-font-size', process.env.VUE_APP_HOMEPAGE_PRICE_FONT_SIZE);
    document.documentElement.style.setProperty('--product-price-font-size', process.env.VUE_APP_PRODUCT_PRICE_FONT_SIZE);
    document.documentElement.style.setProperty('--pages-font-size', process.env.VUE_APP_PAGES_FONT_SIZE);
    document.documentElement.style.setProperty('--pages-title-size', process.env.VUE_APP_PAGES_TITLE_SIZE);
    document.documentElement.style.setProperty('--pages-form-label-size', process.env.VUE_APP_FORM_LABEL_SIZE);
    document.documentElement.style.setProperty('--header-item-font-size', process.env.VUE_APP_HEADER_ITEM_FONT_SIZE);
*/

    const app = createApp(App);
    app.use(store);  // 使用 Vuex store
    app.use(router); // 使用 Vue Router
    app.mount('#app'); // 挂载应用
}

bootstrap();

if (process.env.NODE_ENV === 'production') { // 在 production disable 所有 console log display
    console.log = function() {};
    console.warn = function() {};
    console.error = function() {}; // 您也可以选择保留 console.error
}